import React from "react";
import { TickSvg } from "../../../../../assets";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../../../../styles/styles-css-variables";
import { CheckoutVisualButtonElement, CheckoutVisualDivButtonElement } from "./CheckoutVisualButtonElement";
import cn from "classnames";
import { SmallLoadingSpinner } from "../../../../../routes/modal-loading-spinner";

export const CheckoutVisualButton: React.FC<
  React.PropsWithChildren<{
    isSelected: boolean;
    disabled: boolean;
    onClick?: () => void;
    as?: "button" | "div";
    isLoading?: boolean;
    className?: string;
  }>
> = props => {
  const className = cn({ disabled: props.disabled, loading: props.isLoading }, props.className);

  const sharedProps = {
    isSelected: props.isSelected,
    onClick: props.onClick,
    className: className,
  };

  const loading = (
    <>
      {props.isLoading && (
        <SmallLoadingSpinner
          color={"green"}
          css={css`
            position: absolute;

            right: 8px;
            top: 12px;
          `}
        />
      )}
    </>
  );

  if (props.as === "div") {
    return (
      <CheckoutVisualDivButtonElement {...sharedProps}>
        {loading}

        {props.children}
      </CheckoutVisualDivButtonElement>
    );
  } else {
    return (
      <CheckoutVisualButtonElement {...sharedProps} disabled={props.disabled}>
        {loading}

        {props.children}
      </CheckoutVisualButtonElement>
    );
  }
};
